<template>
  <div class="abk-login-header">
    <div class="abk-login-header-upper">
      <div class="upper-content">
        <pcg-header-fonts class="icon-padding header-fonts" />
        <pcg-header-contrast class="icon-padding header-fonts" />
        <pcg-language-selector
          :supportedLanguages="supportedLanguages"
          class="d-flex align-items-center"
          @localeChange="$emit('localeChange', $event)"
        />
      </div>
    </div>
    <div class="abk-login-header-main bg-white">
      <div class="main-content d-flex align-items-center justify-content-between py-3">
        <div class="logo-container">
          <img v-if="logo" :src="logo" alt="Logo" class="main-logo" />
        </div>

        <!-- Desktop Navigation -->
        <div class="desktop-nav d-none d-lg-flex align-items-center">
          <nav class="main-nav-links d-flex align-items-center">
            <router-link
              v-for="link in visibleLinks"
              :key="link.id"
              :to="{ name: link.path, params: link.query }"
              class="nav-link-item"
            >
              {{ link.name }}
            </router-link>
          </nav>

          <div class="auth-actions d-flex align-items-center ml-4">
            <pcg-btn @click="$emit('login')" size="small" class="login-button ml-auto">
              {{ $t('components.abk_header_navbar.login_btn') }}
            </pcg-btn>
            <span class="buttons-separator">{{ $t('general.or') }}</span>
            <pcg-btn size="small" @click="$emit('register')" variant="additional" class="login-button">
              {{ $t('components.abk_header_navbar.register_btn') }}
            </pcg-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PcgLanguageSelector from 'pcg-core-vue/src/components/PcgLanguageSelector'

export default {
  name: 'AbkLoginHeader',
  components: {
    PcgLanguageSelector
  },
  props: {
    logo: {
      type: String,
      default: null
    },
    supportedLanguages: {
      type: Array,
      required: true
    },
    links: {
      type: Array,
      default: () => []
    },
    currentRole: {
      type: String,
      default: null
    },
    signedIn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibleLinks() {
      return this.links.filter((link) => {
        if (!link.roles) return true
        if (this.signedIn && this.currentRole) {
          return link.roles.includes(this.currentRole)
        }
        return link.roles.length === 0 || link.roles.includes(null)
      })
    }
  },
  methods: {
    getRoute(link) {
      if (link.query) {
        return { name: link.path, query: link.query }
      }
      return { name: link.path }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/vars';

.abk-login-header {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1030;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  .desktop-nav {
    flex: 0.8;
    justify-content: space-between;
  }

  .logo-container {
    width: 260px;
  }

  .abk-login-header-upper {
    background-color: #f8f9fa;
    height: 40px;

    .upper-content {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      padding: 0 15px;
    }
  }

  .abk-login-header-main {
    background-color: #ffffff;

    .main-content {
      min-height: 80px;
      padding: 0 15px;
    }

    .main-logo {
      max-height: 45px;
    }

    .nav-link-item {
      color: #333;
      text-decoration: none;
      font-weight: 500;
      margin: 0 18px;
      font-size: 15px;
      transition: color 0.2s ease;

      &:hover {
        color: $main-active-color;
      }
    }

    .auth-actions {
      .login-link {
        color: #4a4a4a;
        font-weight: 600;
        transition: color 0.2s ease;

        &:hover {
          color: $main-active-color;
        }
      }

      .register-btn {
        background-color: #00b4eb !important;
        border-color: #00b4eb !important;
        border-radius: 30px;
        padding: 8px 24px;
        font-weight: 600;

        &:hover {
          background-color: darken(#00b4eb, 10%) !important;
        }
      }
    }
  }

  .icon-padding {
    padding-right: 15px;
    color: #4a4a4a;
  }

  .header-fonts {
    padding-top: 2px;
  }
}

.contrast {
  .abk-login-header-upper {
    background-color: #171717 !important;
  }
  .abk-login-header-main {
    background-color: #000 !important;
  }
  .nav-link-item,
  .buttons-separator,
  .icon-padding {
    color: #9d9d9d !important;
  }
  .header-fonts {
    color: #000 !important;
  }
}
</style>
